import React, { useEffect, useState, Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { MobileBottomBar } from "./components/MobileBottomBar";
import { ScrollToTop } from "./components/ScrollToTop";
import Home from "./pages/Home";
import Rooms from "./pages/Rooms";
import RoomDetail from "./pages/RoomDetail";
import InteriorVsExterior from "./pages/InteriorVsExterior";
import Amenities from "./pages/Amenities";
import AmenityDetail from "./pages/AmenityDetail";
import IndoorPool from "./pages/IndoorPool";
import MeetingsEvents from "./pages/MeetingsEvents";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Accessibility from "./pages/Accessibility";
import { StayIndex, StayDetail } from "./pages/Stay";
import { ExploreIndex, ExploreDetail } from "./pages/Explore";
import FaqPage from "./pages/FaqPage";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import NotFound from "./pages/NotFound";

// Chat widget is deferred — its bundle is loaded only after the page
// is idle, so it doesn't compete with LCP-critical assets.
const ChatWidget = lazy(() =>
  import("./components/ChatWidget").then((m) => ({ default: m.ChatWidget })),
);

function DeferredChat() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const load = () => setReady(true);
    if ("requestIdleCallback" in window) {
      const id = window.requestIdleCallback(load, { timeout: 3000 });
      return () => window.cancelIdleCallback && window.cancelIdleCallback(id);
    }
    const t = setTimeout(load, 1500);
    return () => clearTimeout(t);
  }, []);
  if (!ready) return null;
  return (
    <Suspense fallback={null}>
      <ChatWidget />
    </Suspense>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <a href="#main" className="skip-to-content" data-testid="skip-to-content">
          Skip to main content
        </a>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rooms" element={<Rooms />} />
          <Route path="/rooms/interior-vs-exterior" element={<InteriorVsExterior />} />
          {/* 301-style SPA redirect from the legacy king-spa-suite slug to the renamed King Jacuzzi Suite */}
          <Route path="/rooms/king-spa-suite" element={<Navigate to="/rooms/king-jacuzzi-suite" replace />} />
          <Route path="/rooms/:slug" element={<RoomDetail />} />
          <Route path="/amenities" element={<Amenities />} />
          <Route path="/amenities/:slug" element={<AmenityDetail />} />
          <Route path="/indoor-pool" element={<IndoorPool />} />
          <Route path="/meetings-events" element={<MeetingsEvents />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/stay" element={<StayIndex />} />
          <Route path="/stay/:slug" element={<StayDetail />} />
          <Route path="/explore" element={<ExploreIndex />} />
          <Route path="/explore/:slug" element={<ExploreDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <MobileBottomBar />
        <DeferredChat />
      </BrowserRouter>
    </div>
  );
}

export default App;
